import { useState } from "react";
import { Flag, TriangleAlert } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { ActionButton } from "../common";

export const DamageBadge = ({ testId }) => <span data-testid={testId} className="inline-flex items-center gap-1.5 rounded border border-red-300 bg-red-50 px-2 py-1 text-xs font-semibold text-red-800"><TriangleAlert size={14} aria-hidden="true" />Damage</span>;

export const RentalPhotoDamage = ({ file, base, canEdit, disabled, onBusyChange, onSaved }) => {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);
  const toggle = async () => {
    if (saving || disabled) return;
    setSaving(true); onBusyChange(true); setError(""); setSaved(false);
    try {
      const { data } = await api.patch(`${base}/${file.id}/damage`, { damage_flag: !file.damage_flag, version: file.damage_version || 0 });
      onSaved(data); setSaved(true);
    } catch (e) { setError(errMsg(e)); }
    finally { setSaving(false); onBusyChange(false); }
  };
  if (!file.damage_flag && !canEdit) return null;
  return <div className="space-y-2">
    <div className="flex flex-wrap items-center gap-2">
      {file.damage_flag && <DamageBadge testId={`rental-photo-damage-badge-${file.id}`} />}
      {canEdit && <ActionButton type="button" variant="secondary" testId={`rental-photo-damage-toggle-${file.id}`} aria-pressed={!!file.damage_flag} disabled={disabled || saving} onClick={toggle} className="min-h-11"><Flag size={15} aria-hidden="true" />{saving ? "Saving…" : file.damage_flag ? "Remove Damage Flag" : "Flag as Damage"}</ActionButton>}
    </div>
    {error && <p data-testid={`rental-photo-damage-error-${file.id}`} role="alert" className="text-sm text-red-700 break-words">{error}</p>}
    {saved && <p data-testid={`rental-photo-damage-saved-${file.id}`} role="status" className="text-xs text-emerald-700">{file.damage_flag ? "Damage flagged" : "Damage flag removed"}</p>}
  </div>;
};
